import Image from "next/image"
import Link from "next/link"
import LogoImg from '../../../public/logo.png'

const Logo = () => {
  return (
    <Link href="/" className="hidden md:flex items-center border border-light/20 w-max py-2 px-3.5 rounded-full font-medium capitalize bg-dark/60 backdrop-blur-sm z-50">
      <div className="w-6 rounded-full overflow-hidden mr-1">
        <Image
          width={64}
          height={64}
          src={LogoImg}
          placeholder="blur"
          title="Tajammal Maqbool Logo"
          alt="Tajammal Maqbool Logo"
          className="rounded-full"
          sizes="20vw"
        />
      </div>
      <span className="font-semibold text-base md:text-lg text-light/70">Tajammal</span>
    </Link>
  )
}

export default Logo